import React,{useState, useEffect} from "react";
import axios from "axios";
import { TiUserDelete } from "react-icons/ti";
import { buildApiUrl } from "../utils/api";

function ClientTable(){
    const [clientData, setClientData] = useState([]);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await axios.get(buildApiUrl('/api/client/getAllClients'));
                console.log("test:",response.data.clients);
                setClientData(response.data.clients); // Assuming the response contains the admin logins
            } catch (error) {
                console.error('Error fetching User data:', error);
            }
        };

        fetchUserData();
    }, []);
    const handleDeleteClient = async (email) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this user?");
        if (confirmDelete) {
            try {
                // Making a DELETE request to backend API
                const response = await axios.delete(buildApiUrl('/api/client/delete'), {
                    data: { email } // Send email in the request body
                });

                if (response.status === 200) {
                    alert('User deleted successfully!');

                    // Update the UI by removing the deleted user from the state
                    setClientData(clientData.filter(user => user.email !== email));
                }
            } catch (error) {
                console.error("Error deleting user:", error);
                alert("Failed to delete the user");
            }
        }
    };
    return(
        <>
            <div className="clientTable">
                <table className="table table-bordered table-striped">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Warehouse Name</th>
                        <th>Warehouse Locations</th>
                        <th>Role</th>
                        {/* <th>Status</th> */}
                        <th>Action</th>
                        {/* <th>Last Login</th> */}
                    </tr>
                </thead>
                <tbody>
                    {clientData.map((user, index) => (
                        <tr key={user.id}>
                            <td>{index + 1}</td> 
                            <td>{user.name}</td>
                            <td>{user.email}</td>
                            <td>{user.warehouseName}</td>
                            <td>{user.warehouseLocation}</td>
                            <td>Client</td>
                            <td>
                            <button className='btn btn-danger' onClick={() => handleDeleteClient(user.email)}>
                                    <TiUserDelete style={{ fontSize: "25px" }} /> Delete Client
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            </div>
        </>
    )
}
export default ClientTable
